import {
  snippets,
  trackLegacy
} from './legacy/snippets';
import Tracker from './legacy/tracker';
import dataLayer from './data-layer';
import {
  serialize,
  defaults,
  excludeSerialize
} from './data-layer';
import {
  DATA_LOCATION,
  GLOBAL_LIB_VAR,
  currentScript
} from './constants';
import {
  headScript,
  bodyScript,
  propertyId
} from './deploys';

require('es6-object-assign').polyfill();

var
  _tracked = false,
  _tracker = false,
  _legacy  = false,
  _isDirty = true,
  _lib     = null,
  _data    = null
;

const
  _trackerEnabled  = currentScript.getAttribute('data-legacy-tracker') !== 'false',
  {RSVP, parseUrl} = window,
  STAGING      = 'pre',
  DEVELOPMENT  = 'des',
  AUTOTRACKING = 'autotracking',
  AUTOTRACK_TIMEOUT = 1000,
  ContentType = Object.freeze({
    noticia:     1,
    video:       2,
    fotogaleria: 3,
    audio:       5,
    blog:        6
  }),
  ready = RSVP.Promise.resolve(DATA_LOCATION)
    .then(_createGlobal)
    .then(_checkRequirements)
    .then(_deployScripts)
    .then(_checkPaywall)
    .then(() => TagManager.set(defaults()))
    .then(_autoTrackSecure)
    .catch((reason) => {throw Error(`[TagManager] ${reason}`);})
;

const TagManager = Object.preventExtensions({
  NAMESPACE:   DATA_LOCATION,
  PROPERTY_ID: propertyId,
  ready,

  update() {
    return this.set(defaults());
  },

  set() {
    var data;

    if (!arguments.length) {throw Error('[TagManager] Empty arguments, expected 1 to n');}

    data = Object.assign(...arguments);
    for (let i in data) {
      if (!~dataLayer.indexOf(i)) {throw Error(`[TagManager] Property not recognized "${i}"`);}
      if (typeof data[i] === 'string') {
        data[i] = data[i]
          .split(',')
          .map((part) => excludeSerialize.indexOf(i) > -1 ? part.trim() : serialize(part.trim()))
          .join(',')
        ;
      }
    }

    Object.assign(_data, data);
    _isDirty = true;

    return this;
  },

  get() {
    return _data;
  },

  getNSO() {
    var nso = window;

    this.NAMESPACE.split('.').forEach((prop) => nso = nso[prop]);

    return nso;
  },

  track(label='view') {
    if (!_isDirty) {throw Error('[TagManager] Your are attempting to track same data twice');}

    _legacyLibs();
    _statsTracker();

    _lib.track(label);
    _isDirty = false;
    _tracked = true;

    return true;
  },

  dump() {
    console.log(this.getNSO());

    return true;
  }
});

export default TagManager;

/* Private */

function _legacyLibs() {
  if (_legacy) {
    trackLegacy();
  } else {
    snippets();
  }

  _legacy = true;
}

function _statsTracker() {
  var site, content, metaTit, trackerUrl, options, env, url, config;

  if (!_trackerEnabled) {return;}

  site    = window.__VOONTO__.lookup('vocento.site');
  content = window.__VOONTO__.lookup('vocento.site.content');
  config  = window.__VOONTO__.lookup('vocento.config.vtm');
  metaTit = document.querySelector('meta[name="title"]');
  env     = '';
  url     = `//${site.subdomain}.${site.tlddomain}${parseUrl(window.location.href).pathname}`;

  if (site.content && !site.content.newsId) {return;}
  if (config.legacyTracker === false) {return;}
  if (_tracker) {return;}

  if (site.env === STAGING || site.env === DEVELOPMENT) {
    env  = `${site.env}.`;
  }

  trackerUrl = config.trackerUrl || `http://${env}metrics.${site.tlddomain}`;

  options = {
    title:       metaTit ? metaTit.content : '',
    section:     _data.seccion,
    contentType: ContentType[_data.tipoContenido],
    origin:      _data.origenContenido,
    clickType:   '', // FUTURE: fill it
    url,
    id:          content.newsId,
    edition:     _data.edicion,
    tags:        `${site.subdomain}.${site.tlddomain}`,
    site:        env ? `metrics.${site.tlddomain}` : undefined
  };

  window.__VOONTO__.when('voonto:ready').then(() => new Tracker(trackerUrl, options));
  _tracker = true;
}

function _createGlobal(namespace) {
  var nso = window;

  namespace.split('.').forEach((prop) => {
    nso[prop] = nso[prop] || {};
    nso = nso[prop];
  });

  return (_data = nso);
}

function _deployScripts() {
  return new RSVP.Promise((resolve, reject) => {
    headScript.onload = () => {
      _lib = window[GLOBAL_LIB_VAR];
      if (document.body) {
        resolve(document.body.appendChild(bodyScript));
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document.body.appendChild(bodyScript));
        });
      }
    };
    headScript.onerror = () => reject('Provider script deployment error');
    document.head.appendChild(headScript);
  });
}

function _checkRequirements() {
  if (!propertyId) {
    throw Error('[TagManager] Developer, you must set "data-property-id" attribute within "<script>" element.');
  }
}

function _autoTrackSecure() {
  setTimeout(function() {
    if (!_tracked) {
      TagManager.set({
        subseccion4: AUTOTRACKING
      }).track();
    }
  }, AUTOTRACK_TIMEOUT);
}

function _checkPaywall() {
  const
    config = window.__VOONTO__.lookup('vocento.config.paywall'),
    provider = window.__VOONTO__.lookup('vocento.__PROVIDER__.paywall')
  ;

  if (config.enabled && !!provider.isNewAnonymousSession) {
    return window.__VOONTO__.when('paywall:ready').then((config) => {
      window.voc_pw_result = config.result;
      window.voc_pw_pid    = config.pid;
      window.voc_pw_meter  = config.meter;
      window.voc_pw_count  = config.count;
      window.voc_pw_max    = config.max;
      window.voc_pw_cookie = config.cookie;
      window.voc_pw_viewed = config.viewed;
    });
  }

  window.voc_pw_result = provider.result;
  window.voc_pw_pid    = provider.pid;
  window.voc_pw_meter  = provider.meter;
  window.voc_pw_count  = provider.count;
  window.voc_pw_max    = provider.max;
  window.voc_pw_cookie = provider.cookie;
  window.voc_pw_viewed = provider.viewed;

  return RSVP.resolve();
}



// WEBPACK FOOTER //
// ./src/tag-manager.js